import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.widget.fund.document');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import moment from 'moment';

@Component({
    selector: 'wiz-portal-lpsysadmin-widget-fund-document',
template: templateSource || '',
    styles: [``],
})
export class PortalLpsysadminWidgetFundDocumentComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() fund: any;

    public loaded: boolean = false;
    public stage: string = "결성";

    public sortableOptions: any = {
        animation: 0,
        handle: '.handle'
    };

    public async ngOnInit() {
        await this.service.init();

        if (!this.fund.extra.document) this.fund.extra.document = {};
        if (!this.fund.extra.document['결성']) this.fund.extra.document['결성'] = { name: '', items: [] };
        if (!this.fund.extra.document['운용']) this.fund.extra.document['운용'] = { name: '', items: [] };
        if (!this.fund.extra.document['해산']) this.fund.extra.document['해산'] = { name: '', items: [] };

        this.fund.extra.document = { ...this.fund.extra.document };
        for (let key in this.fund.extra.document) {
            if (!['결성', '운용', '해산'].includes(key)) {
                delete this.fund.extra.document[key];
            }
        }

        if (['결성', '운용'].includes(this.fund.investment_status)) {
            this.stage = this.fund.investment_status;
        } else {
            this.stage = '해산';
        }

        this.loaded = true;
        await this.service.render();
    }

    public async update() {
        const { code } = await wiz.call("update", { info: JSON.stringify({ id: this.fund.id, extra: this.fund.extra }) });
        if (code == 200) await this.alert("저장되었습니다", "success");
        else await this.alert("오류가 발생했습니다. 다시 저장해주세요.", "error");
        await this.service.render();
    }

    public async clearValue(obj, key) {
        obj[key] = null;
        await this.service.render();
    }

    public async upload(item, target) {
        let files = await this.service.file.select();
        if (files.length == 0) return;

        await this.service.loading.show();
        let fd = new FormData();
        fd.append('upload', files[0]);
        let fdurl = '/file/upload';
        const { url } = await this.service.file.upload(fdurl, fd, async (percent: number, total: number, position: number) => { });
        item[target] = url;
        await this.service.loading.hide();
        await this.service.render();
    }

    public async save(group) {
        if (!group.name || group.name.length < 3) return await this.service.alert.error("3글자 이상으로 서류 그룹 이름을 정해주세요.");
        delete group.isnew;
        await this.service.render();
    }

    public async add() {
        this.fund.extra.document.push({ isnew: true, name: '', items: [] });
        await this.service.render();
    }

    public async addItem(group) {
        group.items.push({});
        await this.service.render();
    }

    public async remove(rows, item) {
        let res = await this.alert("정말로 삭제하시겠습니까?", "error", "취소", "삭제");
        if (!res) return;
        rows.remove(item);
        await this.service.render();
    }

    public async alert(message: string, status: string = 'error', cancel: any = false, action: string = '확인') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }

    public tab: string = '서류설정';

    public async switchTab(tab: string) {
        this.tab = tab;
        if (tab == '서류조회') {
            await this.load();
        }
        await this.service.render();
    }

    public activeTab(tab: string) {
        if (this.tab == tab) return 'cursor-pointer rounded-md bg-zinc-100 px-3 py-2 text-sm font-medium text-zinc-800 flex items-center';
        return 'cursor-pointer rounded-md px-3 py-2 text-sm font-medium text-zinc-600 hover:text-zinc-800 flex items-center';
    }

    public users: any = [];
    public documentSaving: boolean = false;
    public paymentSaving: boolean = false;
    public historyRound: any = null;

    public async load() {
        this.loaded = false;
        const { data } = await wiz.call("status", { id: this.fund.id });
        this.users = data;

        for (let i = 0; i < this.users.length; i++) {
            if (!this.users[i].extra) {
                this.users[i].extra = {};
            }
            if (!this.users[i].extra.document_check) {
                this.users[i].extra.document_check = {};
            }
            if (!this.users[i].extra.document_history) {
                this.users[i].extra.document_history = [];
            }
            if (!this.users[i].extra.payment_history) {
                this.users[i].extra.payment_history = [];
            }
        }

        this.normalizeHistoryRounds();
        const rounds = this.historyRoundNumbers();
        if (rounds.length > 0 && !rounds.includes(this.historyRound)) {
            this.historyRound = rounds[rounds.length - 1];
        }

        this.loaded = true;
        await this.service.render();
    }

    public async updateMember(item, isAlert = true) {
        const { code } = await wiz.call("update_member", { id: this.fund.id, info: JSON.stringify(item) });
        if (isAlert) {
            if (code == 200) await this.alert("저장되었습니다", "success");
            else await this.alert("오류가 발생했습니다. 다시 저장해주세요.", "error");
        }
    }

    public async checkDocument(item, tag, value) {
        if(value === false) {
            this.checked_user_id.push(item.user.id);
            this.show_send_message = true;
            await this.service.render();
        }

        item.extra.document_check[tag] = value;
        await this.updateMember(item, false);
        await this.service.render();
    }

    public checkDocumentClass(item, tag, value) {
        let v = item.extra.document_check[tag];
        if (value) {
            if (v === value) {
                return 'cursor-pointer mr-2 text-blue-600 hover:text-blue-500';
            } else {
                return 'cursor-pointer mr-2 text-zinc-400 hover:text-blue-600';
            }
        } else {
            if (value == null) {
                if (v === value) {
                    return 'cursor-pointer mr-2 text-zinc-900 font-semibold hover:text-zinc-900 hover:font-semibold';
                } else {
                    return 'cursor-pointer mr-2 text-zinc-400 hover:text-zinc-600';
                }
            } else if (value == false) {
                if (v === value) {
                    return 'cursor-pointer mr-2 text-red-600 hover:text-red-900';
                } else {
                    return 'cursor-pointer mr-2 text-zinc-400 hover:text-red-500';
                }
            }
        }

        return 'cursor-pointer mr-2 text-zinc-400 hover:text-blue-600';
    }

    public async checkAccount(item) {
        let res = await this.alert(!item.joined_at ? "입금 확인 처리 하시겠습니까?" : "입금 확인을 취소하시겠습니까?", "success");
        if (!res) return;
        if (!item.joined_at) item.joined_at = moment().format('YYYY-MM-DD HH:mm:ss');
        else item.joined_at = null;
        await this.updateMember(item);
        await this.service.render();
    }

    public toNumber(value) {
        if (value === null || value === undefined || value === '') return 0;
        return Number(String(value).replace(/,/g, '')) || 0;
    }

    public requestRate() {
        return this.toNumber(this.fund?.extra?.requested_amount_rate);
    }

    public completedRate() {
        return this.toNumber(this.fund?.extra?.finished_amount_rate);
    }

    public pledgeAmount(item) {
        return this.toNumber(item?.applied_amount) * this.toNumber(this.fund?.amount_per_share);
    }

    public requestAmount(item) {
        return Math.floor(this.pledgeAmount(item) * this.requestRate() / 100);
    }

    public totalRequestAmount() {
        let total = 0;
        for (let user of this.users || []) total += this.requestAmount(user);
        return total;
    }

    public paidAmount(item) {
        return this.toNumber(item?.joined_budget || item?.extra?.contribution_paid || item?.extra?.paid_amount);
    }

    public totalPaidAmount() {
        let total = 0;
        for (let user of this.users || []) total += this.paidAmount(user);
        return total;
    }

    public stageLabel(stage) {
        if (stage == '결성') return '결성중인 조합';
        if (stage == '운용') return '운용중인 조합';
        return '해산/청산/중간정산';
    }

    public documentHistory(user) {
        const rows = user?.extra?.document_history || [];
        return rows.filter((row) => !row.stage || row.stage == this.stage).slice().reverse();
    }

    public paymentHistory(user) {
        const rows = user?.extra?.payment_history || [];
        return rows.filter((row) => !row.stage || row.stage == this.stage).slice().reverse();
    }

    public rawHistoryRound(row) {
        const round = this.toNumber(row?.round);
        if (round > 0) return round;

        const match = String(row?.title || '').match(/(\d+)\s*회차/);
        if (match) return Number(match[1]) || 0;
        return 0;
    }

    public rowRound(row, fallback = 1) {
        const round = this.rawHistoryRound(row);
        if (round > 0) return round;

        const displayRound = this.toNumber(row?.display_round);
        if (displayRound > 0) return displayRound;
        return fallback;
    }

    public historyMarker(row) {
        const marker = `${row?.title || ''}|${row?.saved_at || ''}`.replace(/^\|+|\|+$/g, '');
        return marker || String(row?.id || '');
    }

    public normalizeHistoryRounds() {
        const groups = [
            { key: 'document_history' },
            { key: 'payment_history' }
        ];

        for (let group of groups) {
            const markers: any = {};
            const counters: any = {};

            for (let user of this.users || []) {
                const rows = user?.extra?.[group.key] || [];
                for (let row of rows) {
                    if (!row) continue;

                    const rawRound = this.rawHistoryRound(row);
                    if (rawRound > 0) {
                        row.display_round = rawRound;
                        continue;
                    }

                    const stage = row.stage || this.stage || '';
                    const marker = this.historyMarker(row);
                    if (!markers[stage]) markers[stage] = {};
                    if (!counters[stage]) counters[stage] = 0;
                    if (!markers[stage][marker]) markers[stage][marker] = ++counters[stage];
                    row.display_round = markers[stage][marker];
                }
            }
        }
    }

    public documentHistoryByRound(user, round) {
        return this.documentHistory(user).filter((row) => this.rowRound(row) == round);
    }

    public paymentHistoryByRound(user, round) {
        return this.paymentHistory(user).filter((row) => this.rowRound(row) == round);
    }

    public historyRoundNumbers() {
        const rounds = [];
        const pushRound = (round) => {
            round = this.toNumber(round);
            if (round > 0 && !rounds.includes(round)) rounds.push(round);
        };

        for (let user of this.users || []) {
            for (let row of this.documentHistory(user)) pushRound(this.rowRound(row));
            for (let row of this.paymentHistory(user)) pushRound(this.rowRound(row));
        }

        const sorted = rounds.sort((a, b) => a - b);
        return sorted.length > 0 ? sorted : [1];
    }

    public activeHistoryRound() {
        const rounds = this.historyRoundNumbers();
        if (rounds.length == 0) return null;
        if (rounds.includes(this.historyRound)) return this.historyRound;
        return rounds[rounds.length - 1];
    }

    public async switchHistoryRound(round) {
        this.historyRound = round;
        await this.service.render();
    }

    public historyRoundClass(round) {
        if (round == this.activeHistoryRound()) {
            return 'inline-flex justify-center rounded-lg bg-zinc-900 px-3 py-2 text-sm font-semibold text-white';
        }
        return 'inline-flex justify-center rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm font-semibold text-zinc-700 hover:bg-zinc-50';
    }

    public hasHistoryRounds() {
        return true;
    }

    public hasDocumentHistory() {
        return (this.users || []).some((user) => this.documentHistory(user).length > 0);
    }

    public hasPaymentHistory() {
        return (this.users || []).some((user) => this.paymentHistory(user).length > 0);
    }

    public responseMessage(res, fallback) {
        return res?.data?.message || res?.message || res?.responseJSON?.data?.message || res?.responseJSON?.message || fallback;
    }

    public async completeDocuments() {
        if (this.documentSaving) return;
        let res = await this.alert(`${this.stageLabel(this.stage)} 제출 파일을 완료 저장하시겠습니까?`, "success", "취소", "서류 완료");
        if (!res) return;

        this.documentSaving = true;
        await this.service.render();
        const result: any = await wiz.call("complete_documents", { id: this.fund.id, stage: this.stage });
        const { code, data } = result;
        this.documentSaving = false;

        if (code == 200) {
            await this.load();
            await this.alert(`${data.files || 0}개 파일을 저장했습니다.`, "success");
        } else {
            await this.alert(this.responseMessage(result, "서류 완료 저장 중 오류가 발생했습니다."), "error");
        }
        await this.service.render();
    }

    public async completePayments() {
        if (this.paymentSaving) return;
        if (this.requestRate() <= 0) {
            return await this.alert("금회 요청액(%)을 입력해주세요.", "error");
        }

        let res = await this.alert(`금회 요청액 ${this.requestRate()}%를 입금완료로 저장하시겠습니까?`, "success", "취소", "입금완료");
        if (!res) return;

        this.paymentSaving = true;
        await this.service.render();
        const result: any = await wiz.call("complete_payments", {
            id: this.fund.id,
            stage: this.stage,
            rate: this.requestRate()
        });
        const { code, data } = result;
        this.paymentSaving = false;

        if (code == 200) {
            if (data && data.fund_extra) this.fund.extra = data.fund_extra;
            await this.load();
            await this.alert(`${data.members || 0}명의 입금 내역을 저장했습니다.`, "success");
        } else {
            await this.alert(this.responseMessage(result, "입금완료 저장 중 오류가 발생했습니다."), "error");
        }
        await this.service.render();
    }


    public target_user: any = null;
    public show_send_message: any = null;
    public checked_user_id: any = [];

    public async clickUser(user) {
        this.target_user = null;
        await this.service.render();
        this.target_user = user.id;
        await this.service.render();
    }

    public userEvent: any = {
        close: async () => {
            this.target_user = null;
            this.show_send_message = null;
            this.checked_user_id = [];
            await this.service.render();
        }
    }
}

export default PortalLpsysadminWidgetFundDocumentComponent;